<template>
  <section
    ref="stickyBlock"
    v-waypoint="{
      active: true,
      callback: onIntersection,
      options: intersectionOptions
    }"
    class="sticky-block"
    :style="wrapperStyles"
  >
    <div
      ref="contentBox"
      class="sticky-block__content"
      :class="{ 'sticky-block__content--sticky': isSticky }"
      :style="{ backgroundColor: backgroundColor, bottom: realBottom, left: left, right: right }"
    >
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'StickyBlock',
  props: {
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    bottom: {
      type: String,
      default: '0'
    },
    left: {
      type: String,
      default: '0'
    },
    right: {
      type: String,
      default: '0'
    },
    wrapperStyles: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    contentHeight: null,
    realBottom: '0',
    isSticky: true,
    intersectionOptions: {
      threshold: [1, 1]
    }
  }),
  mounted() {
    this.setContentHeight();
    this.realBottom = this.bottom;
    window.addEventListener('resize', this.setContentHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setContentHeight);
  },
  methods: {
    onIntersection({ direction }) {
      if (direction === this.$waypointMap.DIRECTION_TOP) {
        console.log('this.$waypointMap.DIRECTION_TOP', this.$waypointMap.DIRECTION_TOP);
        this.isSticky = false;
        this.realBottom = '0';
      }
      if (direction === this.$waypointMap.DIRECTION_BOTTOM) {
        console.log('this.$waypointMap.DIRECTION_BOTTOM', this.$waypointMap.DIRECTION_BOTTOM);
        if (this.$refs.stickyBlock.getBoundingClientRect().top > window.innerHeight / 3) {
          this.isSticky = true;
          this.realBottom = this.bottom;
        }
      }
    },
    setContentHeight() {
      this.contentHeight = this.$refs.contentBox.clientHeight;
    }
  }
};
</script>

<style lang="scss">
.sticky-block {
  &__content {
    position: relative;

    &--sticky {
      position: fixed;
      z-index: 999;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
</style>
